import { PartTypeRow } from 'model/Project/BoMItemRow'
import { AssemblyHeaderDto } from 'services/APIs/InternalAPI/internal-api.contracts'

export function removePricesFromAllBoMItems(state) {
  const clearPrice = (financial) => {
    return {
      ...financial,
      salesPriceOfItems: undefined,
      salesPricePerItem: undefined,
      totalProjectQuantity: undefined,
    }
  }
  state.activeProject.financial = clearPrice(state.activeProject.financial)

  state.assemblyHeadersIds.forEach((headerId) => {
    const header = state.flatView[headerId] as AssemblyHeaderDto
    header.assembly.financial = clearPrice(header.assembly.financial)
  })
  state.partTypeIds.forEach((partTypeId) => {
    const partType = state.flatView[partTypeId] as PartTypeRow
    partType.financial = clearPrice(partType.financial)
  })

  return state
}
